module.exports = __webpack_public_path__ + "static/5-ed77ad24fb24c8a78f6603eb90959758.jpeg";